'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import UIIllustration from 'UIComponents/image/UIIllustration';
import ContentViewport from '../../../components/ContentViewport';
import ContentControlWrapper from '../../../components/ContentControlWrapper';
import { device } from '../../../constants/StyledComponentConstants';
const BASE_CLASS = 'practical-exercise-wrapper';
const StatusDiv = styled.div.withConfig({
  displayName: "PracticalExerciseWrapper__StatusDiv",
  componentId: "f2frz0-0"
})(["@media screen and ", "{display:none !important;}"], device.mobile);

const PracticalExerciseWrapper = ({
  buttons,
  children,
  illustrationName,
  statusSubtitleNode,
  statusTitleI18n
}) => /*#__PURE__*/_jsxs("div", {
  "data-test-id": "practical-exercise-wrapper",
  children: [/*#__PURE__*/_jsx(ContentViewport, {
    wrapperClassName: BASE_CLASS,
    children: /*#__PURE__*/_jsxs("div", {
      className: `${BASE_CLASS}__content`,
      children: [/*#__PURE__*/_jsxs(StatusDiv, {
        className: `${BASE_CLASS}__status`,
        children: [/*#__PURE__*/_jsx(UIIllustration, {
          className: `${BASE_CLASS}__illustration`,
          name: illustrationName
        }), statusTitleI18n && /*#__PURE__*/_jsx("h5", {
          className: `${BASE_CLASS}__status__heading`,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: statusTitleI18n
          })
        }), statusSubtitleNode]
      }), /*#__PURE__*/_jsx("div", {
        className: `${BASE_CLASS}__instructions`,
        children: children
      })]
    })
  }), /*#__PURE__*/_jsx(ContentControlWrapper, {
    className: `${BASE_CLASS}__buttons`,
    children: buttons
  })]
});

PracticalExerciseWrapper.propTypes = {
  buttons: PropTypes.node,
  children: PropTypes.node.isRequired,
  illustrationName: PropTypes.string.isRequired,
  statusSubtitleNode: PropTypes.node,
  statusTitleI18n: PropTypes.string
};
export default PracticalExerciseWrapper;